<script lang="ts" setup>
import { onMounted, nextTick } from 'vue';
import hljs from 'highlight.js/lib/core';
import csharp from 'highlight.js/lib/languages/csharp';
import 'highlight.js/styles/github.css';

hljs.registerLanguage('csharp', csharp);

onMounted(() =>
{
    nextTick(() =>
    {
        document.querySelectorAll('pre code').forEach((block) =>
        {
            hljs.highlightElement(block as HTMLElement);
        });
    });
});
</script>

<template>
    <h5 class="fw-bold2 mb-3">{{ $t('[[[Skrypt dla szablonu dokumentu]]]') }}</h5>
    <h5 class="fw-bold2 mb-3">{{ $t('[[[Skrypt przed eksportem]]]') }}</h5>
    <p
        class="mb-0"
        v-html="$t('[[[Dane, które zwraca skrypt są dopisywane do właściwości dostępnych w zmiennej <b>@Model</b> w szablonie. Z tego względu skrypt musi zwracać słownik typu <b>Dictionary&amp;lt;string, object&amp;gt;</b>]]]')"
    ></p>
    <p />
    <div>
        <h6>{{ $t('[[[Przykład skryptu, który zwraca słownik z dodatkowymi danymi, które można użyć w szablonie:]]]') }}</h6>
        <pre><code class="language-csharp">{{ `using Ideo.Core.Data.Model;

var result = new Dictionary<string, object>();

if (Model.Data is LcFormData doc)
{
    result.Add("RelatedDocsCount", doc.RelatedDocumentList.Count);
}

return result;` }}</code></pre>
    </div>
    <div>
        <h6>{{ $t('[[[Użycie w szablonie:]]]') }}</h6>
        <pre><code class="language-csharp">{{ `@Model.RelatedDocsCount` }}</code></pre>
    </div>
    <div>
        <h6>{{ $t('[[[Skrypt może modyfikować dane całego obiektu @Model, dzięki temu wykona się on tylko raz, a nie dla każdego dokumentu osobno]]]') }}</h6>
        <p class="mb-0" v-html="$t('[[[Dla takiej konfiguracji musimy zwrócić obiekt <b>List&amp;lt;Dictionary&amp;lt;string, object&amp;gt;&amp;gt;</b> dzięki czemu nadpiszemy cały obiekt <b>@Model</b> i skrypt wykona się tylko raz]]]')">
        </p>
        <p />
        <pre><code class="language-csharp">{{ `// @Model
var exportedData = Model.GetExportedDataList();

exportedData.ForEach(p =>
{
    // nadpisanie wartości
    p["Test"] = "TestValue";

    // dopisanie nowej wartości
    p.Add("Test2", "TestValue2");
});

return exportedData;` }}</code></pre>
    </div>
    <div>
        <h6>{{ $t('[[[Użycie w szablonie:]]]') }}</h6>
        <pre><code class="language-csharp">{{ `@Model[0].Test` }}</code></pre>
    </div>
    <h5 class="fw-bold2 mb-3">{{ $t('[[[Skrypt po eksporcie]]]') }}</h5>
    <p class="mb-0">
        {{ $t('[[[Skrypt po eksporcie nie zwraca żadnych danych. Jest on wykonywany w tle po zakończeniu eksportu wszystkich dokumentów.]]]') }}
    </p>
</template>
